import { toggle_loader, disable_loader } from './loader.js';
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    // If the clicked element doesn't have the right selector, bail
    if (!event.target.matches('.installer-swatch-toggle')) return; //get the target input

    var target = event.target.dataset.target ? document.querySelector('select[name="' + event.target.dataset.target + '"]') : false; //get the value

    var value = event.target.dataset.value; //if we have a target and a value...

    if (target && value) {
      //set the value of the target input
      target.value = value; //find all toggles with our target

      var all_toggles = document.querySelectorAll('.installer-swatch-toggle[data-target="' + event.target.dataset.target + '"]'); //loop through all toggles

      for (var i = 0; i < all_toggles.length; i++) {
        //remove the active class
        all_toggles[i].classList.remove('active'); //if this is the one we clicked...

        if (all_toggles[i].dataset.value === value) {
          //add the active class
          all_toggles[i].classList.add('active');
        }
      }
    }
  }, false);
  document.addEventListener('click', function (event) {
    // If the clicked element doesn't have the right selector, bail
    if (!event.target.matches('ff-btn-submit')) return; //wait a few seconds

    setTimeout(function () {
      //fetch any error messages
      var errors = document.querySelectorAll('.error'); //if we have errors

      if (errors && errors.length > 0) {
        //scroll to the first error
        errors[0].scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 250);
  }); //attempt to get all the forms

  var forms = document.querySelectorAll('.installer-form-block form'); //if we have forms

  if (forms) {
    //loop through all forms
    forms.forEach(function (form) {
      //add an event listener to the form
      form.addEventListener('submit', function (event) {
        //toggle the loader
        toggle_loader(); //wait a few seconds and check if there are any errors within this form

        setTimeout(function () {
          //fetch any error messages
          var errors = form.querySelectorAll('.error'); //if we have errors

          if (errors && errors.length > 0) {
            //disable the loader
            disable_loader();
          }
        }, 250);
      });
    });
  }
});